export default __webpack_public_path__ + "static/media/img-fest.0d6d3664.png";